import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import alert from "./plugins/alert";

Vue.config.productionTip = false;

Vue.use(alert);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
